import React from 'react'
import CPAAcordion from './CPAAcordion'
import { v4 as uuid } from 'uuid'
import { Fragment } from 'react'

function CPlanAccordion (props)  {
	const {
		fc_TEXTO_CAJA,
        fc_COLOR_CAJA,
        Caracteristicas,
	} = props

	const searchCharacteristics = (search, TypeFlag = false, Caracteristicas) => {
        let urlModChaCond = 0;
        if (TypeFlag) {
            const data = Caracteristicas.length ? Caracteristicas : [];
            const newCaractData = data.filter(function (CaracData) {
                let CaracDESCRIPCION = []

                CaracDESCRIPCION = CaracData.fc_DESCRIPCION

                return CaracDESCRIPCION.indexOf(search) > -1
            })
            // console.log("to search---------- TypeFlag:", TypeFlag, search, newCaractData, newCaractData.length)
            return newCaractData
        } else {
            const data = Caracteristicas.length ? Caracteristicas : [];
            const newCaractData = data.filter(function (CaracData) {
                let CaracDESCRIPCION = []

                CaracDESCRIPCION = CaracData.fc_DESCRIPCION

                return CaracDESCRIPCION.indexOf(search) === -1
            })
            // let CaractCheckChannel = newCaractData
            newCaractData.forEach((c, index)=>{
        
                if(c.fc_TITULO.toLowerCase().indexOf("canal")>-1 && urlModChaCond === 0 && c?.SETURLMODCH === undefined){
                    c.fc_VALOR = c.fc_VALOR;
                    c.SETURLMODCH = true
                    urlModChaCond = 1
                }
            })
            // console.log("to search---------- TypeFlag:", TypeFlag, search, newCaractData, newCaractData.length)
            return newCaractData
        }
    }

	let CharactBlock = searchCharacteristics('Tipo Footer', false, Caracteristicas)
	const symbolPrice = "RD$";
	let indexBlo = 0;
	let contador = 0;
	let iniciaBloque = 0;
	let contaCar = 0;
    const settingsSliderIcons = {
        infinite: false,
        autoplay: false,
        speed: 800,
        slidesToShow: 5,
        slidesToScroll: 5,
        dots: true,
        arrows: true
    }
  	return (
		<>
			<div className={"cPlanAccordion " + fc_COLOR_CAJA}>
				<div className="cPlanAccordionHeader"> 
					<h4 className="cPlanAccordionHeaderTitle">{fc_TEXTO_CAJA}</h4>
				</div>
				<div className="cPlanAccordionBody">

					
					{
                                CharactBlock ?
                                    CharactBlock.map((caract, index) => {
										contador++;
                                        if(caract.fi_TIPO_VALOR_CARACTERISTICA === 7 ){
                                            indexBlo = 1;
											iniciaBloque = 1;
											contaCar++;
                                        } else if(caract.fi_TIPO_VALOR_CARACTERISTICA === 8 ){
                                            indexBlo = 0;
											iniciaBloque = 0;
											contaCar = 0;
                                        } else if(contaCar >0) {
											contaCar++;
										} else {

										}
										
                                        return indexBlo == 1 && contaCar === 1 || caract.fi_TIPO_VALOR_CARACTERISTICA === 7 || caract.fi_TIPO_VALOR_CARACTERISTICA === 8 ?
											caract.fi_TIPO_VALOR_CARACTERISTICA === 8? <Fragment key={uuid()}></Fragment> :
												<div key={uuid()} className="accordionCPlaA">								
												<CPAAcordion 
													titleAccordion={caract.fc_TITULO}
													indexCar={contador}
													CharactBlock={CharactBlock}
												/>					
												</div>
                                            :	contaCar ===0 ?																					
												<div key={uuid()} className="cPlanAccordionBodyDivCat">
													<h5>{caract.fc_TITULO}</h5>
													<p>{caract.fc_VALOR}</p>
												</div>
											: null
                                        })
                                    : null
                            }
                            
										
                    {/*
					<div className="cPlanAccordionBodyDivCat"> 
						<h5>{fc_DESCRIPCION_OFERTA}</h5>
						<p className="cPlanAccordionPrice">{symbolPrice}{fi_PRECIO_PLAN}</p>
					</div>
                    */}
				</div>
			</div>
		</>
  	)
}

export default CPlanAccordion
